export const getActive = state => state.active
